.app-status-bar {
  overflow: hidden;
  padding: 0 2rem;
  position: relative;
  text-align: center;
  z-index: 20;
}

.app-status-bar__message {
  margin: 0.75rem 0;
}

.app-status-bar--info {
  background-color: var(--color-grey-300);
}

.app-status-bar--warning {
  background-color: var(--color-orange-500);
}

.app-status-bar--error {
  background-color: var(--color-red-600);
  color: var(--color-uva-white);
}
